import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChatUrgent = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20 9C13.928 9 9 13.62 9 19.3125C9 22.6538 9.6875 24.8125 12.4375 27.5625L20 33.75V29.625C26.072 29.625 31 25.005 31 19.3125C31 13.62 26.072 9 20 9Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 14L20 21",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 23L20 25",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgChatUrgent);
export default ForwardRef;
